module.exports = __webpack_public_path__ + "fb6d19258a00caae2546f0a49be074e9.svg";